module.exports = __webpack_public_path__ + "img/henry-fox-talbot.1cf62c38.png";